<template>
  <header class="main-header">
    <img :draggable="false" class="main-header-bg" :src="activityImages.web.header" alt="" />
  </header>
</template>

<script>
import activityImages from '../config/images';

export default {
  name: 'App',
  components: {},
  setup() {
    return {
      activityImages,
    };
  },
};
</script>

<style lang="less">
.main-header {
  width: 100%;
  .main-header-bg {
    width: 100%;
  }
}
@media screen and (max-width: 870px) {
  .main-header {
    display: none;
  }
}
</style>
